<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.lock="loading">
        <div class="main-title">直播管理</div>
        <div class="live-search">
          <div class="search-item">
            <p>直播名称</p>
            <el-input
              v-model="search.keywords"
              placeholder="输入直播名称或视频号"
            ></el-input>
          </div>
          <div class="search-item">
            <p>筛选条件</p>
            <el-select v-model="search.status" clearable placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="search-item">
            <div class="search-btn" @click="searchHandle">搜索</div>
          </div>
        </div>
        <div class="live-btn" @click="addActive('')">添加活动</div>
        <!-- 直播列表 -->
        <div class="live-list" v-if="liveList.length > 0">
          <div class="live-item" v-for="(item, index) in liveList" :key="index">
            <div class="live-top">
              <!-- <el-image
                class="live-image"
                v-if="item.thumb"
                :src="$imgOssUrl + item.thumb"
              ></el-image> -->
              <template v-if="item.thumb">
                <el-image
                  class="live-image"
                  v-if="item.thumb.includes('https://oss.larspring.com')"
                  :src="item.thumb"
                ></el-image>
                <el-image
                  class="live-image"
                  v-else-if="item.thumb.includes('/var/')"
                  :src="$imgOssUrl + item.thumb.substring(1)"
                ></el-image>
                <el-image
                  class="live-image"
                  v-else
                  :src="$imgOssUrl + item.thumb"
                ></el-image>
              </template>
              <el-image
                class="live-image"
                v-else
                :src="require('../assets/defalut.jpg')"
              ></el-image>

              <p class="live-title">{{ item.title }}</p>
              <p class="review" v-if="item.status == '1'">审核中</p>
              <p class="review reject" v-if="item.status == '3'">已驳回</p>
              <p class="review live-status" v-if="item.liveStatus == 'unStart'">
                未开始
              </p>
              <p class="review live-status" v-if="item.liveStatus == 'live'">
                直播中
              </p>
              <p class="review live-status" v-if="item.liveStatus == 'end'">
                已结束
              </p>
              <p class="review live-status" v-if="item.liveStatus == 'waiting'">
                等待中
              </p>
              <p
                class="review live-status"
                v-if="item.liveStatus == 'playback'"
              >
                回放中
              </p>
              <p class="review live-status" v-if="item.liveStatus == 'banpush'">
                已禁播
              </p>
            </div>
            <div class="live-bottom">
              <div @click="addActive(item.id)">编辑</div>
              <div v-if="item.status == 0" @click="applyLiveHandle(item.id)">
                申请直播
              </div>
              <div
                v-if="item.status == 2"
                @click="liveStart(item.id, item.channel_id)"
              >
                开始直播
              </div>
              <div class="red" @click="del(index, item.id)">删除</div>
            </div>
          </div>
        </div>
        <nodata v-if="liveList.length == 0"></nodata>
        <el-pagination
          v-if="liveList.length > 0"
          background
          class="main-page"
          layout="total, prev, pager, next"
          :current-page="search.page_no"
          :total="totals"
          @current-change="pageChange"
        >
        </el-pagination>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">跳过</div>
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <!-- 24.9.1 已知悉改成下一步 dxm-->
            <div class="btn next-btn" @click="next('known')">
              {{ lastStep ? "完成" : "下一步" }}
            </div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
    </div>
    <!-- 直播活动详情弹框 -->
    <el-dialog
      :title="ruleForm.id ? '编辑活动' : '添加活动'"
      :visible.sync="isActive"
      width="40%"
    >
      <div class="badge-details">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          label-position="right"
          class="demo-ruleForm"
        >
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="活动海报" prop="thumb">
            <div style="display: flex">
              <div class="image-wrap" v-if="ruleForm.thumb">
                <div class="image">
                  <el-image
                    v-if="ruleForm.thumb.includes('https://oss.larspring.com')"
                    :src="ruleForm.thumb"
                  ></el-image>
                  <el-image
                    v-else-if="ruleForm.thumb.includes('/var/')"
                    :src="$imgOssUrl + ruleForm.thumb.substring(1)"
                  ></el-image>
                  <el-image
                    v-else
                    :src="$imgOssUrl + ruleForm.thumb"
                  ></el-image>
                  <div class="upload-span">
                    <span class="upload-icon" @click.stop="handleImgRemove"
                      ><i class="el-icon-delete"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div v-if="!ruleForm.thumb">
                <el-upload
                  :action="$Url"
                  list-type="picture-card"
                  :headers="headers"
                  :multiple="false"
                  :on-success="handleImgsSuccess"
                  :on-error="handleImgsError"
                  :show-file-list="false"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
            <div class="img-tips">
              上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl
            </div>
          </el-form-item>
          <el-form-item label="活动类型" prop="category">
            <el-select
              v-model="ruleForm.category"
              placeholder="选择活动类型"
              clearable
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              type="datetimerange"
              :range-separator="ruleForm.date ? '-' : ''"
              start-placeholder="选择时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动类型" prop="activity_type">
            <el-radio-group v-model="ruleForm.activity_type">
              <el-radio label="1">线上</el-radio>
              <el-radio label="2">线下</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动地点" prop="schedule">
            <el-input
              type="textarea"
              v-model="ruleForm.schedule"
              placeholder="输入活动地点"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isActive = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 直播设置弹框 -->
    <el-dialog title="直播设置" :visible.sync="isActiveSet" width="40%">
      <div class="badge-details">
        <el-form
          :model="ruleSetForm"
          :rules="ruleSet"
          ref="ruleSetForm"
          label-width="100px"
          label-position="right"
          class="demo-ruleForm"
        >
          <el-form-item label="联系人" prop="contacts">
            <el-input v-model="ruleSetForm.contacts"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input
              v-model.number="ruleSetForm.mobile"
              maxlength="11"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isActiveSet = false">取 消</el-button>
        <el-button type="primary" @click="submitSetForm('ruleSetForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  polyvList,
  getCategoryList,
  polyvAdd,
  polyvEdit,
  polyvDetail,
  applyLive,
  delPolyv,
  skipOrReadStep,
} from "@/api/api";
import moment from "moment";
import top from "../components/top.vue"; //头部
import nodata from "../components/nodata.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
var checkTime = (rule, value, callback) => {
  if (new Date(value[0]) < new Date()) {
    callback(new Error("时间必须晚于当前时间"));
  } else {
    return callback();
  }
};
/* 手机号 */
var isMobileNumber = (rule, value, callback) => {
  if (!value) {
    return new Error("请输入手机号");
  } else {
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
    const isPhone = reg.test(value);
    value = Number(value); //转换为数字
    if (typeof value === "number" && !isNaN(value)) {
      //判断是否为数字
      value = value.toString(); //转换成字符串
      if (value.length < 0 || value.length < 11) {
        //判断是否为11位手机号
        callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    } else {
      callback(new Error("请输入手机号"));
    }
  }
};
export default {
  components: { top, navMenu, nodata },
  name: "liveList",
  data() {
    return {
      loading: false,
      active: 3,
      detail: {},
      search: {
        keywords: "",
        status: "",
        page_no: 1,
        page_size: 10,
      },
      options: [
        {
          value: "1",
          label: "待审核",
        },
        {
          value: "2",
          label: "已审核",
        },
        {
          value: "3",
          label: "已驳回",
        },
      ],
      totals: 0,
      liveList: [],
      isActive: false,
      ruleForm: {
        id: "",
        title: "",
        thumb: "",
        category: "",
        date: "",
        activity_type: "1",
        schedule: "",
      },
      rules: {
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        category: [
          { required: true, message: "请选择活动类型", trigger: "change" },
        ],
        date: [
          { required: true, message: "请选择时间", trigger: "change" },
          { validator: checkTime, trigger: "change" },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
        selectableRange: `${Date().split(" ")[4]} - 23:59:59`,
      },
      categoryOptions: [],
      headers: {},
      isActiveSet: false,
      ruleSetForm: {
        id: "",
        contacts: "",
        mobile: "",
      },
      ruleSet: {
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: isMobileNumber, trigger: "blur" },
        ],
      },
      lastStep: false,
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "liveList";
    });
    this.active = index;
    //24.9.1 判断是否为最后一步 dxm
    if (index == stepMenuList.length - 1) {
      this.lastStep = true;
    }
    this.detail = stepMenuList[index];
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    //24.8.16 获取直播分类 dxm
    this.getCategoryListData();
    //24.8.16 获取直播列表 dxm
    this.getPolyvList();
  },
  created() {},
  methods: {
    addActive(id) {
      if (id) {
        this.ruleForm.id = id;
        this.getPolyvDetail(id);
      } else {
        this.ruleForm.id = "";
        this.ruleForm.title = "";
        this.ruleForm.thumb = "";
        this.ruleForm.category = "";
        this.ruleForm.date = "";
        this.ruleForm.activity_type = "";
        this.ruleForm.schedule = "";
      }
      this.isActive = true;
    },
    //获取直播分类
    getCategoryListData() {
      getCategoryList()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.categoryOptions = data;
          }
        })
        .catch((err) => {});
    },
    //搜索
    searchHandle() {
      this.getPolyvList();
    },
    //获取直播列表
    getPolyvList() {
      this.loading = true;
      let data = this.$qs.stringify(this.search);
      polyvList(data)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 1) {
            let { data } = res.data;
            this.liveList = data.lists;
            this.totals = data.count;
          }
        })
        .catch((err) => {});
    },
    // 分页切换
    pageChange(val) {
      this.search.page_no = val;
      this.getPolyvList();
    },
    //获取直播详情
    getPolyvDetail(id) {
      let data = this.$qs.stringify({
        id,
      });
      polyvDetail(data)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            data.date = [
              moment(data.starttime * 1000).format("YYYY-MM-DD HH:mm:ss"),
              moment(data.endtime * 1000).format("YYYY-MM-DD HH:mm:ss"),
            ];
            data.category = Number(data.category);
            this.ruleForm = data;
          }
        })
        .catch((err) => {});
    },
    //活动弹框
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { id, title, thumb, category, date, activity_type, schedule } =
            this.ruleForm;
          let starttime = parseInt(new Date(date[0]).getTime() / 1000);
          let endtime = parseInt(new Date(date[1]).getTime() / 1000);
          let data = {
            id,
            title,
            thumb,
            category,
            starttime,
            endtime,
            activity_type,
            schedule,
          };
          if (this.ruleForm.id > 0) {
            this.saveEditLive(data);
          } else {
            this.saveAddLive(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //添加活动直播
    saveAddLive(data) {
      polyvAdd(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getPolyvList();
            this.isActive = false;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    //编辑活动直播
    saveEditLive(data) {
      polyvEdit(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getPolyvList();
            this.isActive = false;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    //海报上传成功
    handleImgsSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.ruleForm.thumb = resData.data.url;
    },
    //海报上传失败
    handleImgsError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //海报删除
    handleImgRemove(index) {
      this.ruleForm.thumb = "";
    },
    //申请直播
    applyLiveHandle(id) {
      this.ruleSetForm.id = id;
      this.isActiveSet = true;
    },
    //直播设置上传
    submitSetForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleSetForm;
          applyLive(data)
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                let index = this.liveList.findIndex(
                  (item) => item.id === this.ruleSetForm.id
                );
                if (index !== -1) {
                  this.liveList[index].status = 1;
                }
                this.isActiveSet = false;
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除直播间
    del(index, id) {
      this.$confirm("确认要删除吗？")
        .then((_) => {
          delPolyv({ id })
            .then((res) => {
              if (res.data.code == 1) {
                this.liveList.splice(index, 1);
                this.$message.success(res.data.msg);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err, "===err");
            });
        })
        .catch((_) => {});
    },
    //开始直播
    liveStart(id, channelId) {
      this.$router.push({
        path: "/liveSet",
        query: {
          id,
          channelId,
        },
      });
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        // if (this.detail.action == 1 || this.detail.action == 4) {
        //   this.toPath();
        // } else {
        //   this.$message.warning("请完善信息!");
        // }
        if (this.detail.action >= 2) {
          this.toPath();
        } else if (this.detail.is_verify == 1) {
          this.$message.warning("请完善信息!");
        } else {
          this.toPath();
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            //24.9.1 判断是否为最后一步,如果是最后一步,刷新页面不跳转 dxm
            if (!this.lastStep) {
              this.toPath();
            } else {
              window.location.reload();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.img-tips {
  color: red;
  line-height: 20px;
  font-size: 12px;
  padding-top: 5px;
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
.content {
  margin-bottom: 0;
  .live-search {
    display: flex;
    flex-wrap: wrap;
    align-items: end;
    margin-top: 30px;
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    .search-item {
      width: 30%;
      font-size: 14px;
      color: #7f8fa4;
      line-height: 22px;
      margin-right: 24px;
      margin-bottom: 10px;
      p {
        margin-bottom: 7px;
      }
      .el-select {
        width: 100%;
      }
      .search-btn {
        width: 103px;
        height: 38px;
        color: #fff;
        font-size: 14px;
        line-height: 38px;
        text-align: center;
        background: #fc933f;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }
  .live-btn {
    width: 103px;
    height: 36px;
    font-size: 14px;
    color: #fff;
    margin: 20px 0;
    text-align: center;
    line-height: 36px;
    border-radius: 3px;
    cursor: pointer;
    background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
  }
  .live-list {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    min-height: calc(100vh - 590px);
    .live-item {
      width: 225px;
      height: 184px;
      margin-right: 20px;
      background: #fff;
      box-shadow: 0 1px 7px -1px rgba(0, 0, 0, 0.1);
      .live-top {
        height: 130px;
        margin: 5px;
        position: relative;
        .live-image {
          width: 100%;
          height: 100%;
        }
        .live-title {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          color: #fff;
          min-height: 30px;
          font-size: 14px;
          overflow: hidden;
          padding: 6px 10px;
          white-space: nowrap;
          box-sizing: border-box;
          text-overflow: ellipsis;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.12) 30%,
            rgba(0, 0, 0, 0.5) 100%
          );
        }
        .review {
          position: absolute;
          top: 10px;
          left: 10px;
          width: 56px;
          height: 22px;
          font-size: 12px;
          color: #fff;
          text-align: center;
          line-height: 22px;
          background: #faad14;
          border-radius: 4px;
        }
        .reject {
          background: red;
        }
        .live-status {
          background: rgba(60, 129, 230, 0.95);
        }
      }
      .live-bottom {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        > div {
          flex: 1;
          font-size: 14px;
          color: #1677ff;
          cursor: pointer;
          text-align: center;
          border-right: 1px solid #ddd;
          &:last-child {
            border-right: 0 none;
          }
        }
        .red {
          color: #ff4d4f;
        }
      }
    }
  }
}
.badge-details {
  .details-title {
    font-size: 16px;
    font-weight: 500;
    color: #3d83e9;
    padding-bottom: 20px;
    border-bottom: 1px solid #3d83e9;
  }
  .demo-ruleForm {
    padding: 10px 70px 10px 0;
    .el-select,
    .el-date-editor--datetimerange.el-input,
    .el-date-editor--datetimerange.el-input__inner {
      width: 100%;
    }
  }
}
.image-wrap {
  display: flex;
  .image {
    margin-right: 10px;
    margin-bottom: 10px;
    width: 148px;
    height: 148px;
    border-radius: 6px;
    position: relative;
    /deep/ .el-image {
      width: 148px;
      height: 148px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      .el-image__inner {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .upload-span {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($color: #000, $alpha: 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: all 0.1s;
      border-radius: 6px;
      .upload-icon {
        color: #fff;
        font-size: 22px;
      }
    }
    &:hover {
      .upload-span {
        opacity: 1;
      }
    }
  }
}
.main-page {
  width: 100%;
  padding: 10px 20px;
  text-align: right;
  box-sizing: border-box;
}
@media only screen and (max-width: 767px) {
  .content {
    padding: 0 0 80px 0;
  }
  .content .live-search .search-item {
    width: 100%;
  }
  .content {
    .live-list {
      .live-item {
        width: 165px;
        height: 165px;
        margin-right: 10px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        .live-top {
          height: 110px;
        }
        .live-bottom > div {
          font-size: 12px;
        }
      }
    }
  }
  /deep/ .el-dialog {
    width: 90% !important;
  }
  /deep/ .el-dialog__body {
    padding: 10px;
  }
  .badge-details .demo-ruleForm {
    padding: 10px;
  }
  .main-page {
    padding: 20px 0;
  }
}
</style>